<template>
	 <v-container style="padding: 0;">
		 <v-dialog title="撤销核销课次" v-model="hideShow" width="800px" persistent>
			<v-card>
				<v-card-title>
					<span>撤销核销课次</span>
					<v-spacer></v-spacer>
					<v-btn icon @click="cancel">
						<v-icon>mdi-close-circle</v-icon>
					</v-btn>
				</v-card-title>
				<div style="width: 100%; height: 2px; background-color: #eeeeee;"></div>
				<v-card-text class="mt-5">
					<template>
					  <v-data-table :headers="approve.headers" :items="approve.detailList" class="elevation-1"
						disable-pagination hide-default-footer item-key="id" :loading="loadding" loading-text="正在加载,请稍候......">
					    
						<template v-slot:item.status="{item}">
							{{statusName(item.status)}}
						</template>
						<template v-slot:item.consumeType="{item}">
							{{ consumeTypeName(item.consumeType) }}
						</template>
						<template v-slot:item.reduceQty="{item}">
							<span v-if="item.consumeType=='2'">{{item.reduceQty * item.classHourPrice}}元</span>
							<span v-if="item.consumeType=='1'">{{item.reduceQty }}课时</span>
						</template>
						<template v-slot:item.reduceAmount="{item}">
							<span v-if="item.consumeType=='2'" class="red--text">{{item.reduceQty * item.classHourPrice}}元</span>
							<span v-if="item.consumeType=='1'" class="red--text">{{item.reduceQty }}课时</span>
						</template>
					  </v-data-table>
					</template>
				</v-card-text>
				<v-card-actions>
					<v-checkbox v-model="approve.comfirmed" label="确认数据无误" color="red" dense></v-checkbox>
					<v-spacer></v-spacer>
					
					<v-btn @click="cancel">取消</v-btn>
					<v-btn @click="submitCancelApprove" :disabled="approve.submitting|| !approve.comfirmed" :loading="approve.submitting" color="info">确认撤销</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	 </v-container>
</template>

<script>
	export default {
		name:"cancel-approve-record",
		props: {
			//显示/隐藏。
			show: {
				type: Boolean,
				default: false
			},
			recordId:{
				type:String,
				default:""
			}
			
		},
		watch:{
			show(newVal,oldVal){
				console.log("newVal",newVal);
				this.hideShow = newVal;
				if(this.hideShow){
					this.approve.comfirmed = false;
					this.approve.detailList=[];
					this.getRecordDetailList(this.recordId);
				}
			}
		},
		data(){
			return {
				loadding:false,
				hideShow:this.show,
				approve:{
					submitting:false,
					comfirmed:false,
					classStatusItems:[
						{id:"1",text:"到课"},
						{id:"2",text:"请假"},
						{id:"3",text:"旷课"},
					],
					headers:[
						{text: '核销时间',value: 'createAt',sortable: false},
						{text: '学员姓名',value: 'studentName',sortable: false},
						{text: '扣费方式',value: 'consumeType',sortable: false},
						{text: '核销扣除',value: 'reduceQty',width:'110',sortable: false},
						{text: '上课状态',value: 'status',width:'120',sortable: false},
						{text: '本次退还',value: 'reduceAmount',width:'100',sortable: false},
					],
					detailList:[],  //详细列表
				}
			}
		},
		mounted() {
			console.log("cancel-approve-record mounted");
		},
		methods:{
			consumeTypeColor(state){
				let color = "";
				if (state === "1") {
					color = "info";
				} else if (state === "2") {
					color = "success";
				}
				
				return color;
			},
			consumeTypeName(state){
				let color = "未知";
				if (state === "1") {
					color = "扣课时";
				} else if (state === "2") {
					color = "扣金额";
				}
				
				return color;
			},
			statusName(state){
				let color = "未知";
				if (state === "1") {
					color = "到课";
				} else if (state === "2") {
					color = "请假";
				}else if (state === "3") {
					color = "旷课";
				}
				
				return color;
			},
			cancel(){
				this.$emit("cancel","");
			},
			submitCancelApprove(){
				//撤销核销
				// api 
				this.approve.submitting = true;
				const that = this;
				let url = `/edu/class/record/approve/cancel/${this.recordId}`;
				
				this.axios.post(url).catch(() => {
					that.approve.submitting = false;
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.approve.submitting = false;
							that.$noty.success("撤销成功");
							that.$emit("success","");
							return;
						} else {
							that.approve.submitting = false;
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.approve.submitting = false;
						that.$noty.error('网络请求失败');
					}
				});
			},
			getRecordDetailList(recordId){
				
				// 获取核销的详情明细
				if (!recordId){
					return
				}
				
				this.loadding = true;
				const that = this;
				let url = `/edu/class/record/approved/detail/`+recordId;
							
				this.axios.get(url).then(response => {
					
					if (response.data["code"] === 200) {
						that.loadding = false;
						that.approve.detailList = response.data["data"] ? response.data["data"] : [];
						
						console.log(">>>>>>>>>>>>>>获取核销明细>>>>>>>>>>>>>>");
						console.log(that.approve.detailList);
						console.log(">>>>>>>>>>>>>>获取核销明细>>>>>>>>>>>>>>");
						
						return
					}
					that.loadding = false;
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			}
		}
	}
	
</script>

<style>
</style>
